module.exports = __webpack_public_path__ + "img/image11@2x.b87611c9.png";